module.exports = __webpack_public_path__ + "img/roulotte-la-k-nett-action-cuisine.12ed1168.jpg";